<template>
  <div class="load-sample-group">
    <div class="load-sample">
      <app-button @onclick="loadSampleJSON(sampleForm[0].form)">
        Load Sample JSON
        <tooltip :text="TOOLTIP_TEXT.LOAD_SAMPLE_JSON"></tooltip>
      </app-button>
      <div class="dropdown" @click="toggleDropdown()"><i class="arrow down"></i></div>
    </div>
    <div v-for="form in sampleForm" :key="form.label">
      <div class="sample-option" @click="changeForm(form)"> {{ form.label }} </div>
    </div>
  </div>
</template>

<script>
import RegForm from "../ceagmojt2022_shareholder_reg_form.json";
import ProxyForm from "../sample_proxy_form.json";
import AppButton from "./AppButton.vue";
import Tooltip from "./Tooltip.vue";
import { TOOLTIP_TEXT } from "../mixins/constant-mixin";

export default {
  name: "LoadJson",
  data() {
    return {
      TOOLTIP_TEXT: TOOLTIP_TEXT,
      sampleForm: [
        {
          label: "Shareholder Reg Form",
          form: RegForm,
        },
        {
          label: "Proxy Form",
          form: ProxyForm,
        },
      ],
      selectedForm: {},
    }
  },
  components: {
    "app-button": AppButton,
    "tooltip": Tooltip,
  },
  methods: {
    loadSampleJSON: function (form) {
      this.$emit("loadSampleJSON", form);
    },
    changeForm: function (formObj) {
      this.closeDropdown();
      this.loadSampleJSON(formObj.form);
    },
    toggleDropdown: function () {
      const arrow = this.$el.querySelector(".arrow");
      if (arrow.classList.contains("down")) {
        this.openDropdown();
      } else {
        this.closeDropdown();
      }
    },
    openDropdown: function() {
      const arrow = this.$el.querySelector(".arrow");
      const options = this.$el.querySelectorAll(".sample-option");
      arrow.classList.replace("down", "up");
      options.forEach(option => option.classList.add("show"))
    },
    closeDropdown: function() {
      const arrow = this.$el.querySelector(".arrow");
      const options = this.$el.querySelectorAll(".sample-option");
      arrow.classList.replace("up", "down");
      options.forEach(option => option.classList.remove("show"));
    }
  },
}
</script>

<style scoped>
.load-sample-group {
  margin-right: auto;
  margin-left: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: 10px;
}

.load-sample-group * {
  background: #0073c3;
  color: #fff;
  font-size: 13px;
}

.load-sample {
  display: flex;
  border-radius: 5px 5px 0 0;
  border: 1px solid #000;
}

.load-sample > * {
  margin: 0;
}

.dropdown {
  padding: 8px 12px;
  background: transparent;
  border-left: 1px solid #000;
  cursor: pointer;
}

.arrow {
  border: solid #fff;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transition: transform .2s ease-in-out, margin 0s linear .1s;
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  margin-bottom: -2px;
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  margin-bottom: -5px;
}

.sample-option {
  cursor: pointer;
  padding: 12px 16px;
  display: none;
  border: 1px solid #000;
  border-top: none;
  background: #fff;
  color: #000;
}

.sample-option:hover {
  background: #e3e3e3;
}

.show {
  display: block;
}

.selected {
  background: #c4c4c4;
}
</style>